/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'PPE_EQUIPMENT_AND_CLOTHING_PROVIDED_IS_IN_GOOD_CONDITION_AND_RE',
              'PPE_IS_THE_CORRECT_SIZE_FOR_WORKERS',
              'PPE_EQUIPMENT_SUCH_AS_HEARING_PROTECTION_IS_PROVIDED_WHERE_NOIS',
              'PPE_EQUIPMENT_AND_CLOTHING_PROVIDED_IS_CONSISTENTLY_AND_EFFECTI',
              'WARNINGS_EITHER_THROUGH_VERBAL_OR_WRITTEN_COMMUNICATION_ARE_USE',
              'PENALTIES_MONETARY_OR_OTHERWISE_ARE_USED_TO_ENSURE_THAT_WORKERS',
              'THE_FACILITY_ENSURES_THE_APPROPRIATE_AND_SAFE_STORAGE_OF_PPE_EQ',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_measures_in_place_relate_1: valueSchema,
  },
}
